<lib-header>
  <app-auth-controls headerActions (feedbackRequested)="errorReporting.openFeedback()" />
</lib-header>

<main class="flex-1 bg-[#090b0d]">
  <router-outlet />
</main>
<lib-footer [showAnalyticsSettings]="true" (openAnalyticsSettings)="analytics.openSettings()" />
<lib-analytics-consent (acceptConsent)="analytics.accept()" (rejectConsent)="analytics.reject()" />
